import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { Typography, Avatar, Box, CircularProgress } from '@mui/material';
import { useRequest } from 'ahooks';
import { fetchCharacterById } from '../api/Rick&MortyReq';
const HeroDetails = () => {
    var _a;
    const { id } = useParams();
    const { data, loading, error } = useRequest(() => (id ? fetchCharacterById(Number(id)) : Promise.reject('No ID')), {
        refreshDeps: [id],
    });
    if (loading || !data)
        return (_jsx(Box, { sx: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }, children: _jsx(CircularProgress, {}) }));
    if (error)
        return _jsx(Typography, { variant: "h6", color: "error", children: "Error loading character details." });
    return (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }, children: [_jsx(Avatar, { src: data.image, sx: { width: 200, height: 200, mb: 2, border: '4px solid #1976d2' } }), _jsx(Typography, { variant: "h4", children: data.name }), _jsxs(Typography, { variant: "subtitle1", color: "text.secondary", children: ["Status: ", data.status] }), _jsxs(Typography, { variant: "body1", children: ["Species: ", data.species] }), _jsxs(Typography, { variant: "body1", children: ["Gender: ", data.gender] }), _jsxs(Typography, { variant: "body1", children: ["Location: ", (_a = data.location) === null || _a === void 0 ? void 0 : _a.name] })] }));
};
export default HeroDetails;
